<template>
  <Card class="menu-card">
    <el-menu slot="title" :default-active="activeIndex" mode="horizontal" @select="handleSelect">
      <el-menu-item index="1">加工费设置</el-menu-item>
      <el-menu-item index="2">配送费设置</el-menu-item>
      <!-- <el-menu-item index="3">辅料费设置</el-menu-item> -->
    </el-menu>
    <div slot="content">
      <Processing v-if="menuIndex == 1" />
      <Delivery v-if="menuIndex == 2" />
      <Ingredients v-if="menuIndex == 3" />
    </div>
  </Card>
</template>

<script lang="js">
import Processing from "./Processing.vue"; // 标签管理
import Delivery from "./Delivery.vue"; // 科室管理
import Ingredients from "./Ingredients.vue"; // 称号设置
export default {
  name: "Scheduling",
  components: { Processing, Delivery, Ingredients },
  data() {
    return {
      activeIndex: "1", // 默认激活菜单
      menuIndex: "1", // 菜单索引
    }
  },
  created() {
    let index = this.$session.get('chargeIndex')
    if (index) this.activeIndex = this.menuIndex = index;
  },
  methods:{
    // 切换当前显示组件
    handleSelect(key) {
      this.menuIndex = key;
      this.$session.set('chargeIndex', key);
    }
  }
};
</script>